import React from 'react';

import { MarketsCount, StreamLink } from 'components';
import type { Analytics } from 'services/analytics';

import './streamMarketCount.scss';

interface Props {
    topMarketsCount: number;
    streamWithTitle: boolean;
    marketsCount: number | undefined;
    linkToMatch: string | null;
    isResultPage?: boolean;
    isLive: boolean;
    toggleStream?: () => void;
    isViewerOpen: boolean;
    isSportEventViewable: boolean;
    analytics?: Analytics;
}

const StreamMarketCount: React.FC<Props> = props => {
    const {
        marketsCount,
        linkToMatch,
        streamWithTitle,
        topMarketsCount,
        isResultPage = false,
        isLive,
        isViewerOpen,
        isSportEventViewable,
        analytics,
        toggleStream,
    } = props;

    const hasStreamLink = isSportEventViewable && (!isResultPage || isLive);

    return (
        <div
            styleName="container"
            className="__app-StreamMarketCount-container"
        >
            {hasStreamLink && (
                <StreamLink
                    analytics={analytics}
                    linkToMatch={linkToMatch}
                    withTitle={streamWithTitle}
                    onClick={toggleStream}
                    isViewerOpen={isViewerOpen}
                />
            )}

            <div styleName="market-count">
                <MarketsCount
                    marketsCount={marketsCount}
                    topMarketsCount={topMarketsCount}
                    linkToMatch={linkToMatch}
                    isHiddenCount={isResultPage}
                />
            </div>
        </div>
    );
};

export default StreamMarketCount;
